<template>
  <vjs-modal v-bind="$options.propsData"
             :title="title"
             :icon="icon"
             :width="width"
             height="auto"
             title-justify="center"
             :close-button="false"
             :name="name">
    <template slot="body-content">
      <slot v-if="$scopedSlots[`default`]" />
      <div v-else class="d-flex flex-column justify-content-center the-warning">
        <h4>
          <span>
            {{ full_message }}
          </span>
        </h4>
        <br>
        <h4>
          Are you sure?
        </h4>
      </div>
    </template>
    <template slot="body-controls">
      <b-button variant="ss-danger" :disabled="waiting_callback" @click="() => close(true)">
        <loader v-if="waiting_callback" small class="mr-2" /> {{ deleteButtonText }}
      </b-button>
      <b-button variant="ss-cancel" :disabled="waiting_callback" @click="() => close(false)">
        <loader v-if="waiting_callback" small class="mr-2" /> {{ cancelButtonText }}
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  name: `delete-confirm-modal`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: `delete-confirm`,
    },
    title: {
      type: String,
      required: false,
      default: `Deletion Warning`,
    },
    icon: {
      type: String,
      required: false,
      default: `la la-exclamation-triangle`,
    },
    entityType: {
      type: String,
      required: false,
      default: 'object',
    },
    entitiesToDelete: {
      type: Array,
      required: false,
      default: null,
    },
    deleteCount: {
      type: Number,
      required: false,
      default: null,
    },
    message: {
      type: String,
      required: false,
      default: null,
    },
    deleteButtonText: {
      type: String,
      required: false,
      default: 'Delete',
    },
    cancelButtonText: {
      type: String,
      required: false,
      default: 'Cancel',
    },
    width: {
      type: String,
      required: false,
      default: '450',
    },
  },
  computed: {
    delete_count() {
      return this.deleteCount ?? this.entitiesToDelete?.length ?? 1;
    },
    full_message() {
      return this.message ?? `You're about to delete ${this.delete_count} ${this.entityType}${this.delete_count > 1 ? `s` : ``}!`;
    },
  },
  methods: {
    close(confirmed) {
      this.close_data.confirm = confirmed;
      this.complete();
    },
  },
};
</script>

<style lang="scss" scoped>
.the-warning {
  font-weight: bold;

  h4 {
    display: inline-block;
    text-align: center;
  }
}

:deep(.vjs-modal-header) {
  justify-content: center;
}

</style>
